import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10s1.5 1.688 1.5 2.688c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5c0-1 1.5-2.688 1.5-2.688zM6.657.636l6.657 6.657-6.364 6.364c-.39.39-1.024.39-1.414 0L1.293 9.414c-.39-.39-.39-1.023 0-1.414L6.95 2.343l-1-1 .707-.707zm1 2.414L2.708 8h8.484l.707-.706L7.657 3.05z",
    transform: "translate(-57 -263) translate(37 171) translate(0 80) translate(20 12) matrix(-1 0 0 1 16 0)"
  })))))));
});